import { List } from "immutable";
import { createSelector } from "reselect";

import { ContentId } from "../models/state/contents/Contents";
import { SectionId } from "../models/state/sections/Sections";
import {
  getAllSections,
  getSection,
  getSectionParentId,
  getSectionSectionIds
} from "./state";
import * as sectionsSelectors from "./state/sections";

type State = any;

export function getAllSubSubSectionIds(
  state: any,
  sectionId: string
): List<string> {
  return getSectionSectionIds(state, sectionId).reduce(
    (sectionIds: any, subsectionId: string) => {
      return sectionIds.concat(getSectionSectionIds(state, subsectionId));
    },
    List()
  );
}

export function makeGetAllSectionContentIds(
  sectionId: SectionId
): (arg0: State) => List<ContentId> {
  return createSelector(getAllSections, sections =>
    sectionsSelectors.getAllSectionContentIds(sections, sectionId)
  );
}

export function makeGetAllSectionContentIdsFromSections(
  sectionIds: List<SectionId>
): (arg0: State) => List<ContentId> {
  return createSelector(getAllSections, sections =>
    sectionsSelectors.getAllSectionContentIdsFromSections(sections, sectionIds)
  );
}

export const getSectionCourseId = (state: State, sectionId: string): string => {
  const parentId = getSectionParentId(state, sectionId);
  const section = getSection(state, parentId);

  if (!section) {
    return parentId;
  }

  return getSectionCourseId(state, parentId);
};
